import {createContext} from 'react';
import {Account} from "../features/accounts-management";


type UserAccountContextType = {
    userAccount: Account | undefined,
    refreshUserAccount?: () => Promise<void>,
}


export const UserAccountContext = createContext<UserAccountContextType>({
                                                                            userAccount: {} as Account,
                                                                            refreshUserAccount: async () => { /* noop default */ },
                                                                        });

